module.exports = __webpack_public_path__ + "img/afval-fase-1.78437f8f.png";